import _defineProperty from "@babel/runtime/helpers/defineProperty";
import cc from 'classcat';
import PropTypes from 'prop-types';
import AfterpayIcon from '../icons/Afterpay';
import css from './Afterpay.module.scss';
import Info from '../icons/Info';
import Overlay from '../Ovly';
import Price from '../Price';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var PRICE_MINIMUM = 30;
export var AFTERPAY = 'Afterpay';

var Afterpay = function Afterpay(_ref) {
  var centered = _ref.centered,
      price = _ref.price;

  var calcPrice = function calcPrice(prodPrice) {
    return prodPrice / 4;
  };

  var button = /*#__PURE__*/_jsxs("div", {
    className: css.infoIcons,
    children: [/*#__PURE__*/_jsx("span", {
      children: "by"
    }), "\xA0", /*#__PURE__*/_jsx(AfterpayIcon, {
      className: css.afterpaySmall
    }), "\xA0", /*#__PURE__*/_jsx(Info, {
      className: css.info
    })]
  });

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: css.root,
      children: /*#__PURE__*/_jsxs("span", {
        className: cc([css.messaging, _defineProperty({}, css.centered, centered)]),
        children: ["or 4 interest-free installments", price > PRICE_MINIMUM && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("span", {
            children: "\xA0of\xA0"
          }), /*#__PURE__*/_jsx(Price, {
            price: calcPrice(price),
            className: css.price
          }), "\xA0"]
        }), /*#__PURE__*/_jsxs(Overlay, {
          label: "Afterpay",
          button: button,
          children: [/*#__PURE__*/_jsxs("header", {
            className: css.modalHeader,
            children: [/*#__PURE__*/_jsx("span", {
              className: css.installmentsBy,
              children: "Installments by"
            }), /*#__PURE__*/_jsx(AfterpayIcon, {
              className: css.modalIcon
            }), /*#__PURE__*/_jsx("h3", {
              className: css.modalTitle,
              id: "after-pay-title",
              children: "Shop now. Enjoy now. Pay later."
            }), /*#__PURE__*/_jsx("span", {
              className: css.modalTitleDesc,
              id: "after-pay-description",
              children: "4 interest-free payments, every two weeks, at checkout"
            })]
          }), /*#__PURE__*/_jsxs("ol", {
            className: css.paymentSteps,
            children: [/*#__PURE__*/_jsxs("li", {
              className: css.paymentStep,
              children: [/*#__PURE__*/_jsxs("h4", {
                className: css.stepTitle,
                children: ["Select ", AFTERPAY]
              }), /*#__PURE__*/_jsxs("p", {
                className: css.stepDescription,
                children: ["Choose ", AFTERPAY, " at checkout and use your existing payment card."]
              })]
            }), /*#__PURE__*/_jsxs("li", {
              className: css.paymentStep,
              children: [/*#__PURE__*/_jsx("h4", {
                className: css.stepTitle,
                children: "Complete checkout"
              }), /*#__PURE__*/_jsx("p", {
                className: css.stepDescription,
                children: "No long forms, approval decision online. Enjoy your purchase right away!"
              })]
            }), /*#__PURE__*/_jsxs("li", {
              className: css.paymentStep,
              children: [/*#__PURE__*/_jsx("h4", {
                className: css.stepTitle,
                children: "Pay over 4 payments"
              }), /*#__PURE__*/_jsx("p", {
                className: css.stepDescription,
                children: "Pay every two weeks with zero interest! No fees when you pay on time."
              })]
            })]
          }), /*#__PURE__*/_jsxs("footer", {
            className: css.modalFooter,
            children: ["You must be over 18, a resident of the U.S. and meet additional eligibility criteria to qualify. Late fees apply. Estimated payment amounts shown on product pages exclude taxes and shipping charges, which are added at checkout. Click\xA0", /*#__PURE__*/_jsx("a", {
              className: css.termsLink,
              href: "https://www.afterpay.com/en-US/terms-of-service",
              rel: "noopener noreferrer",
              target: "_blank",
              children: "here"
            }), "\xA0for complete terms. \xA9 2019 ", AFTERPAY]
          })]
        })]
      })
    })
  });
};

Afterpay.defaultProps = {
  centered: true
};
Afterpay.propTypes = {
  centered: PropTypes.bool,
  price: PropTypes.number.isRequired
};
export default Afterpay;